import { Link } from "react-router-dom";
import LogoText from "./LogoText";
import Brand from "./Brand";

export default function SiteFooter() {
  return (
    <footer data-testid="site-footer" className="mt-24 border-t border-border/60 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-8 py-14 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-start gap-4 mb-4">
            <LogoText size="md" as="span" />
            <div>
              <div className="text-xs tracking-wider-cap text-foreground">Building God's Kingdom through Faith &amp; Wellness</div>
            </div>
          </div>
          <p className="text-sm text-foreground max-w-md">An all-in-one platform — funnels, courses, store, emails, academy, community &amp; affiliate rewards. Open to everyone. Family-friendly. Clean.</p>
        </div>
        <div>
          <div className="font-serif-display text-lg text-red-wine mb-3">Platform</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/pricing" className="hover:text-red-wine">Pricing</Link></li>
            <li><Link to="/signup" className="hover:text-red-wine">Get All Access · $49</Link></li>
            <li><Link to="/login" className="hover:text-red-wine">Sign In</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-serif-display text-lg text-red-wine mb-3">Ministry</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/founder" className="hover:text-red-wine">Mike</Link></li>
            <li><Link to="/books" className="hover:text-red-wine">Books</Link></li>
            <li><Link to="/directory" className="hover:text-red-wine">Member Directory</Link></li>
            <li><Link to="/honest-truth" className="hover:text-red-wine">The Honest Truth</Link></li>
            <li><Link to="/vendor-standards" className="hover:text-red-wine">Vendor Standards · Submit Product</Link></li>
            <li><a href="mailto:mylivegoodplan@gmail.com" className="hover:text-red-wine">Contact</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border/60 py-5 text-center text-xs text-foreground">
        © {new Date().getFullYear()} <Brand suffix=".com"/> — "Go into all the world and preach the gospel." Mark 16:15
      </div>
    </footer>
  );
}
